import { Dispatch, SetStateAction, useState } from 'react';
import { useDebouncedEffect } from '@britishcouncil/react-common';

export function useDebouncedState<T>(
  initialValue: T,
  delay: number
): [T, Dispatch<SetStateAction<T>>, T] {
  const [value, setValue] = useState<T>(initialValue);
  const [debouncedValue, setDebouncedValue] = useState<T>(initialValue);

  useDebouncedEffect(() => setDebouncedValue(value), delay, [value]);

  return [value, setValue, debouncedValue];
}
